import ServicePageLayout from '@/components/ServicePageLayout';

const EVENTS_DATA = {
  id: 'events',
  title: 'Event Services',
  subtitle: 'From corporate galas to cultural celebrations — every event deserves to be remembered beautifully.',
  category: 'Events',
  heroImage: '/images/Events/Hero_Image.jpeg',
  sections: [
    {
      id: 'corporate-events',
      title: 'Corporate Events',
      items: [
        {
          title: 'Conference & Summit Coverage',
          description: 'Professional documentation of keynotes, panels, networking sessions, and corporate summits.',
          image: '/images/Events/Conference_&_Summit.jpeg',
        },
        {
          title: 'Product Launch Events',
          description: 'Dynamic visual coverage of product unveilings, brand activations, and launch celebrations.',
          image: '/images/Events/Product_Launch_Events.jpg',
        },
        {
          title: 'Awards & Gala Nights',
          description: 'Elegant documentation of corporate award ceremonies, gala dinners, and formal evening events.',
          image: '/images/Events/Awards_&_Gala_Nights.jpg',
        },
      ],
    },
    {
      id: 'social-events',
      title: 'Social & Private Events',
      items: [
        {
          title: 'Birthday Celebrations',
          description: 'From milestone birthdays to intimate gatherings — capturing the joy and excitement of your celebration as it naturally unfolds.',
          image: '/images/Events/Birthday_Celebrations.jpg',
        },
        {
          title: 'Anniversary Parties',
          description: 'Documenting the love and togetherness of anniversary celebrations with warmth and elegance.',
          image: '/images/Events/Anniversary_Parties.jpg',
        },
        {
          title: 'Baby Showers & Gender Reveals',
          description: 'Colorful, joyful coverage of baby showers, gender reveals, and family celebrations filled with laughter and warmth.',
          image: '/images/Events/Baby_Showers_&_Gender_Reveals.jpg',
        },
        {
          title: 'Private Parties & Dinners',
          description: 'Exclusive coverage of private gatherings, house parties, and intimate dinner events.',
          image: '/images/Events/Private_Parties_&_Dinners.jpg',
        },
      ],
    },
    {
      id: 'cultural-events',
      title: 'Cultural & Community Events',
      items: [
        {
          title: 'Religious & Festival Coverage',
          description: 'Respectful and vibrant documentation of religious ceremonies, festivals, and cultural celebrations.',
          image: '/images/Events/Religious_&_Festival_Coverage.jpg',
        },
        {
          title: 'Charity & Fundraiser Events',
          description: 'Impactful coverage of charity galas, fundraisers, and community-driven events.',
          image: '/images/Events/Charity_Events.jpg',
        },
        {
          title: 'Exhibition & Art Show Coverage',
          description: 'Artistic documentation of art exhibitions, gallery openings, and cultural showcases.',
          image: '/images/Events/Exhibition_&_Art_Show.jpg',
        },
      ],
    },
    {
      id: 'live-shows',
      title: 'Live Shows & Performances',
      items: [
        {
          title: 'Concert & Music Event ',
          description: 'High-energy photography and videography of live concerts, music festivals, and DJ sets.',
          image: '/images/Events/Concert_Event.jpg',
        },
        {
          title: 'Theatre & Dance Performances',
          description: 'Capturing the drama, movement, and artistry of live theatre and dance productions.',
          image: '/images/Events/Dance_Performances.jpg',
        },
        {
          title: 'Stand-Up & Comedy Shows',
          description: 'Lively documentation of comedy shows, open mics, and entertainment events.',
          image: '/images/Events/Comedy_Shows.jpg',
        },
      ],
    },
    {
      id: 'event-films',
      title: 'Films',
      items: [
        {
          title: 'Event Highlight Film',
          description: 'A cinematic summary of your event capturing the atmosphere, key moments, and energy.',
          image: '/images/Events/Event_Highlight_Film.png',
        },
        {
          title: 'Live Streaming',
          description: 'Professional multi-camera live streaming for virtual audiences and hybrid events.',
          image: '/images/Events/Live_Streaming.jpg',
        },
        {
          title: 'Recap & Social Media Reels',
          description: 'Quick-turnaround social media content optimized for Instagram, LinkedIn, and YouTube.',
          image: '/images/Events/Recap_&_Social_Media_Reels.jpg',
        },
      ],
    },
    {
      id: 'event-addons',
      title: 'Add-Ons',
      items: [
        {
          title: 'Photo Booth Setup',
          description: 'Interactive branded photo booth with instant prints and digital sharing for your guests.',
          image: '/images/Events/Photo_Booth_Setup.jpg',
        },
        {
          title: 'Drone Aerial Coverage',
          description: 'Stunning aerial shots of outdoor events, venues, and large-scale gatherings.',
          image: '/images/Events/Drone_Aerial_Coverage.jpg',
        },
        {
          title: 'Same-Day Social Media Edit',
          description: 'Real-time edited photos and stories posted to your social channels during the event.',
          image: '/images/Events/Social_Media_Coverage.jpg',
        },
      ],
    },
    {
      id: 'event-deliverables',
      title: 'Deliverables',
      items: [
        {
          title: 'High-Resolution Event Photos',
          description: 'Professionally edited high-resolution images delivered via cloud within 7-10 business days.',
          image: '/images/Events/High_Res_Event_Photos.jpg',
        },
        {
          title: 'Event Video Package',
          description: 'Complete video deliverables including highlight film, full footage, and social media cuts.',
          image: '/images/Events/Event_Video.jpg',
        },
        {
          title: 'Online Event Gallery',
          description: 'Branded online gallery with download access, sharing capabilities, and print ordering.',
          image: '/images/Events/Online_Event_Gallery.jpg',
        },
      ],
    },
  ],
};

export default function EventsPage() {
  return <ServicePageLayout data={EVENTS_DATA} />;
}
